import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-list-card',
  templateUrl: './list-card.component.html',
  styleUrl: './list-card.component.scss',
})
export class ListCardComponent {
  @Input() items: any[] = [];
  @Input() titleField: string = '';
  @Input() sublistField: string = '';
  @Input() subitemField: string = '';
  @Input() isLoading: boolean = false;

  @Output() addClicked = new EventEmitter<any>();
  @Output() editClicked = new EventEmitter<any>();
  @Output() subitemEditClicked = new EventEmitter<{item: any, subitem: any}>();

  onAddClick(item: any) {
    this.addClicked.emit(item);
  }

  onEditClick(item: any) {
    this.editClicked.emit(item);
  }

  onSubitemEditClick(item: any, subitem: any) {
    this.subitemEditClicked.emit({item, subitem});
  }
}
